const imageAlbumAssoc = [

    {
        "id": 42,
        "usr_id": 1,
        "img_name": "piramid-building_mini.jpg",
        "img_id": 3,
        "album_name": "new album",
        "album_id": 1,
        "created_on": "2022-09-24 06:24:26",
        "status": "active"
    },
    {
        "id": 43,
        "usr_id": 1,
        "img_name": "piramid-building_mini.jpg",
        "img_id": 3,
        "album_name": "Beach",
        "album_id": 10,
        "created_on": "2022-09-24 06:24:26",
        "status": "active"
    },
    // {
    //     "id": 43,
    //     "usr_id": 1,
    //     "img_name": "a7243d30-4beb-410c-88cb-66119fda5355_mini.jpeg",
    //     "img_id": 229,
    //     "album_name": "Beach",
    //     "album_id": 10,
    //     "created_on": "2022-09-24 06:24:26",
    //     "status": "active"
    // },
    // {
    //     "id": 53,
    //     "usr_id": 1,
    //     "img_name": "8111d92c-caa0-4a6f-9a51-68fc2f4f0a75_mini.jpeg",
    //     "img_id": 283,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:25:08",
    //     "status": "active"
    // },
    // {
    //     "id": 55,
    //     "usr_id": 1,
    //     "img_name": "c7d9a656-f2bc-4f69-b1e3-5e309325de02_mini.jpeg",
    //     "img_id": 280,
    //     "album_name": "Beach",
    //     "album_id": 10,
    //     "created_on": "2022-09-24 06:25:14",
    //     "status": "active"
    // },
    // {
    //     "id": 58,
    //     "usr_id": 1,
    //     "img_name": "911d5340-11b1-4a2c-b72e-d13864fce2d3_mini.jpeg",
    //     "img_id": 270,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:25:21",
    //     "status": "active"
    // },
    // {
    //     "id": 59,
    //     "usr_id": 1,
    //     "img_name": "85cef16b-a0f0-4446-83f9-3380ecc8e501_mini.jpeg",
    //     "img_id": 261,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:25:23",
    //     "status": "active"
    // },
    // {
    //     "id": 61,
    //     "usr_id": 1,
    //     "img_name": "0defcf4a-6038-4441-ad1b-5cad08257eca_mini.jpeg",
    //     "img_id": 243,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:25:35",
    //     "status": "active"
    // },
    // {
    //     "id": 62,
    //     "usr_id": 1,
    //     "img_name": "837dea11-943e-45ee-9a2d-a857c3b697f0_mini.jpeg",
    //     "img_id": 241,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:25:36",
    //     "status": "active"
    // },
    // {
    //     "id": 63,
    //     "usr_id": 1,
    //     "img_name": "6c3ce3bf-1303-41c2-b3d2-a8fb2fa3e712_mini.jpeg",
    //     "img_id": 240,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:25:38",
    //     "status": "active"
    // },
    // {
    //     "id": 64,
    //     "usr_id": 1,
    //     "img_name": "8f7fdb71-7bcc-4109-9c52-6f8fae59a3b0_mini.jpeg",
    //     "img_id": 227,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:25:41",
    //     "status": "active"
    // },
    // {
    //     "id": 65,
    //     "usr_id": 1,
    //     "img_name": "3a7b3eda-5b2b-4374-8349-2341942dc26e_mini.jpeg",
    //     "img_id": 223,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:25:43",
    //     "status": "active"
    // },
    // {
    //     "id": 66,
    //     "usr_id": 1,
    //     "img_name": "f43c94de-a563-4bcc-9cf5-78ffa691b026_mini.jpeg",
    //     "img_id": 222,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:25:44",
    //     "status": "active"
    // },
    // {
    //     "id": 67,
    //     "usr_id": 1,
    //     "img_name": "bb853923-2c25-4d53-adf3-9ae99c7aa33f_mini.jpeg",
    //     "img_id": 220,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:25:46",
    //     "status": "active"
    // },
    // {
    //     "id": 68,
    //     "usr_id": 1,
    //     "img_name": "ada99808-d2c0-47e3-bace-08faf2f81605_mini.jpeg",
    //     "img_id": 216,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:25:48",
    //     "status": "active"
    // },
    // {
    //     "id": 69,
    //     "usr_id": 1,
    //     "img_name": "c2716db9-0658-4864-9fd2-b330c5cb09d6_mini.jpeg",
    //     "img_id": 214,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:25:49",
    //     "status": "active"
    // },
    // {
    //     "id": 70,
    //     "usr_id": 1,
    //     "img_name": "0dc4ba4d-fe8c-4464-b81d-c5fd70d2d399_mini.jpeg",
    //     "img_id": 211,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:25:51",
    //     "status": "active"
    // },
    // {
    //     "id": 72,
    //     "usr_id": 1,
    //     "img_name": "5d8636e2-9bc6-46d9-9383-13eddc6c87ee_mini.jpeg",
    //     "img_id": 166,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:25:59",
    //     "status": "active"
    // },
    // {
    //     "id": 73,
    //     "usr_id": 1,
    //     "img_name": "3b2f9f84-94de-4640-97e2-768243f65d65_mini.jpeg",
    //     "img_id": 164,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:26:01",
    //     "status": "active"
    // },
    // {
    //     "id": 74,
    //     "usr_id": 1,
    //     "img_name": "87bf5ac4-5db8-4721-8a21-21d8aa5dacb4_mini.jpeg",
    //     "img_id": 154,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:26:03",
    //     "status": "active"
    // },
    // {
    //     "id": 75,
    //     "usr_id": 1,
    //     "img_name": "b09cf122-054c-4a86-9dec-519e94b0f579_mini.jpeg",
    //     "img_id": 153,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:26:04",
    //     "status": "active"
    // },
    // {
    //     "id": 76,
    //     "usr_id": 1,
    //     "img_name": "img_2392_mini.JPG",
    //     "img_id": 23,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:26:13",
    //     "status": "active"
    // },
    // {
    //     "id": 78,
    //     "usr_id": 1,
    //     "img_name": "img_2408_mini.JPG",
    //     "img_id": 17,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:26:16",
    //     "status": "active"
    // },
    // {
    //     "id": 79,
    //     "usr_id": 1,
    //     "img_name": "img_2408_mini.JPG",
    //     "img_id": 16,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:26:17",
    //     "status": "active"
    // },
    // {
    //     "id": 80,
    //     "usr_id": 1,
    //     "img_name": "img_2392_mini.JPG",
    //     "img_id": 11,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:26:19",
    //     "status": "active"
    // },
    // {
    //     "id": 81,
    //     "usr_id": 1,
    //     "img_name": "img_2429_mini.JPG",
    //     "img_id": 10,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:26:20",
    //     "status": "active"
    // },
    // {
    //     "id": 82,
    //     "usr_id": 1,
    //     "img_name": "img_2430_mini.JPG",
    //     "img_id": 8,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:26:22",
    //     "status": "active"
    // },
    // {
    //     "id": 83,
    //     "usr_id": 1,
    //     "img_name": "img_2393_mini.JPG",
    //     "img_id": 3,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:26:24",
    //     "status": "active"
    // },
    // {
    //     "id": 84,
    //     "usr_id": 1,
    //     "img_name": "img_2408_mini.JPG",
    //     "img_id": 2,
    //     "album_name": "Dishes",
    //     "album_id": 11,
    //     "created_on": "2022-09-24 06:26:25",
    //     "status": "active"
    // },
    // {
    //     "id": 86,
    //     "usr_id": 1,
    //     "img_name": "9b41e04d-b78d-46e2-9048-c70be60e3977_mini.jpeg",
    //     "img_id": 151,
    //     "album_name": "Fruit",
    //     "album_id": 12,
    //     "created_on": "2022-09-24 06:33:05",
    //     "status": "active"
    // },
    // {
    //     "id": 87,
    //     "usr_id": 1,
    //     "img_name": "c46c481f-7e67-46ab-b3d5-ac9980fa59e1_mini.jpeg",
    //     "img_id": 146,
    //     "album_name": "Fruit",
    //     "album_id": 12,
    //     "created_on": "2022-09-24 06:33:07",
    //     "status": "active"
    // },
    // {
    //     "id": 88,
    //     "usr_id": 1,
    //     "img_name": "6088ae33-effa-4caa-91c2-2d7884f6727e_mini.jpeg",
    //     "img_id": 149,
    //     "album_name": "Fruit",
    //     "album_id": 12,
    //     "created_on": "2022-09-24 06:33:09",
    //     "status": "active"
    // },
    // {
    //     "id": 89,
    //     "usr_id": 1,
    //     "img_name": "76bb716d-bdbf-445b-ba46-d934a90eb055_mini.jpeg",
    //     "img_id": 144,
    //     "album_name": "Fruit",
    //     "album_id": 12,
    //     "created_on": "2022-09-24 06:33:10",
    //     "status": "active"
    // },
    // {
    //     "id": 103,
    //     "usr_id": 1,
    //     "img_name": "circeo-beach_mini.jpeg",
    //     "img_id": 550,
    //     "album_name": "Beach",
    //     "album_id": 10,
    //     "created_on": "2022-10-01 19:20:46",
    //     "status": "active"
    // },
    // {
    //     "id": 104,
    //     "usr_id": 1,
    //     "img_name": "piramid-building_mini.jpeg",
    //     "img_id": 549,
    //     "album_name": "Beach",
    //     "album_id": 10,
    //     "created_on": "2022-10-01 19:20:48",
    //     "status": "active"
    // },
    // {
    //     "id": 105,
    //     "usr_id": 1,
    //     "img_name": "the-liberty-homes_mini.jpeg",
    //     "img_id": 548,
    //     "album_name": "Beach",
    //     "album_id": 10,
    //     "created_on": "2022-10-01 19:20:55",
    //     "status": "active"
    // },
    // {
    //     "id": 106,
    //     "usr_id": 1,
    //     "img_name": "8111d92c-caa0-4a6f-9a51-68fc2f4f0a75_mini.jpeg",
    //     "img_id": 283,
    //     "album_name": "Desserts",
    //     "album_id": 15,
    //     "created_on": "2022-10-02 05:53:10",
    //     "status": "active"
    // },
    // {
    //     "id": 107,
    //     "usr_id": 1,
    //     "img_name": "911d5340-11b1-4a2c-b72e-d13864fce2d3_mini.jpeg",
    //     "img_id": 270,
    //     "album_name": "Desserts",
    //     "album_id": 15,
    //     "created_on": "2022-10-02 05:53:28",
    //     "status": "active"
    // },
    // {
    //     "id": 108,
    //     "usr_id": 1,
    //     "img_name": "8f7fdb71-7bcc-4109-9c52-6f8fae59a3b0_mini.jpeg",
    //     "img_id": 227,
    //     "album_name": "Pasta",
    //     "album_id": 14,
    //     "created_on": "2022-10-02 05:59:15",
    //     "status": "active"
    // },
    // {
    //     "id": 109,
    //     "usr_id": 1,
    //     "img_name": "3a7b3eda-5b2b-4374-8349-2341942dc26e_mini.jpeg",
    //     "img_id": 223,
    //     "album_name": "Pasta",
    //     "album_id": 14,
    //     "created_on": "2022-10-02 05:59:17",
    //     "status": "active"
    // },
    // {
    //     "id": 110,
    //     "usr_id": 1,
    //     "img_name": "f43c94de-a563-4bcc-9cf5-78ffa691b026_mini.jpeg",
    //     "img_id": 222,
    //     "album_name": "Pasta",
    //     "album_id": 14,
    //     "created_on": "2022-10-02 05:59:19",
    //     "status": "active"
    // },
    // {
    //     "id": 111,
    //     "usr_id": 1,
    //     "img_name": "bb853923-2c25-4d53-adf3-9ae99c7aa33f_mini.jpeg",
    //     "img_id": 220,
    //     "album_name": "Pasta",
    //     "album_id": 14,
    //     "created_on": "2022-10-02 05:59:22",
    //     "status": "active"
    // },
    // {
    //     "id": 112,
    //     "usr_id": 1,
    //     "img_name": "a-wonderful-woman_mini.jpeg",
    //     "img_id": 551,
    //     "album_name": "Beach",
    //     "album_id": 10,
    //     "created_on": "2022-10-02 07:51:58",
    //     "status": "active"
    // },
    // {
    //     "id": 113,
    //     "usr_id": 1,
    //     "img_name": "8111d92c-caa0-4a6f-9a51-68fc2f4f0a75_mini.jpeg",
    //     "img_id": 283,
    //     "album_name": "Cars",
    //     "album_id": 13,
    //     "created_on": "2022-10-02 17:58:51",
    //     "status": "active"
    // }
]

export default imageAlbumAssoc;